import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ChangeControlDetails } from '../../models/change-control-details';
import { ChangeControlService } from '../../services/changecontrol.service';
import { ChangeControlLookUp } from '../../models/change-control-look-up';
import { firstValueFrom, forkJoin } from 'rxjs';
import { ResponsibleSubBUService } from '../../../../shared/services/responsible-sub-bu.service';
import { AssignmentGroupSharedDataService } from '../../../../shared/services/assignment-group-shared-data.service';
import { ChangecontrolPersistenceService } from '../../services/changecontrol-persistence.service';
import { ChangeControlLabels } from '../../enums/change-control-labels';
import { ChangeControlDisplayDetails } from '../../../change-control-details/models/change-control-display-details';
import { Assignment } from '../../models/assignment';
import { AssignmentDisplayDetails } from '../../../../change-control/change-control-details/models/assignment-display-details';
import { ChangeControlLibraryConstants } from '../../constants/changeControlLibraryConstants';
import { ChangeControlPhase } from '../../enums/change-control-phases';
import { ChangeControlAttachmentDetails } from '../../../../change-control/change-control-details/models/change-control-attachment-details';
import { formatDate } from '@angular/common';
import { UsersService } from '../../../../../app/shared/services/users.service';
import { UserType } from '../../../../../app/shared/enums/user-type';

@Component({
  selector: 'app-change-control-general-details',
  templateUrl: './change-control-general-details.component.html',
  styleUrls: ['./change-control-general-details.component.scss'],
})
export class ChangeControlGeneralDetailsComponent {
  @Input() changeControlDetails !: ChangeControlDisplayDetails
  @Output() activateTabIndex = new EventEmitter<number>();
  isChangeControlSaveInProgress = false;
  changeControlSaveProgressMessage =
  ChangeControlLibraryConstants.ChangeControl_Save_InProgress;
  errorMessages: string[] = [];
  changeControlForm!: FormGroup;
  validationErrorOnApproverAndReviewerEnable = false;
  isInternalClientContactMandatory = false;
  isInternalClientContactRequired = false;
  assignmentGroups: any;
  saveClicked = false;
  minStartDateValue: Date = new Date();
  valueField: string = 'value';
  labelField: string = 'name';
  mandatoryFields = this.getDefaultMandatoryFieldsObject();
  infoForRiskAssessmentRequired =
  ChangeControlLibraryConstants.ChangeControl_InfoForRiskAssessment;
  infoForClientNotificationOrApprovalRequired =
  ChangeControlLibraryConstants.ChangeControl_InfoForclientNotificationOrApprovalRequired;
  changeControlErrorReminder: string =
  ChangeControlLibraryConstants.ChangeControl_ErrorText;
  lookupData!: ChangeControlLookUp;
  eQMSScopeList: any = [];
  islookupDataLoaded = false;
  userList: any = [];
  sbuList: any = [];
  changeControlBindData: any = {};
  formData!: ChangeControlDetails;
  deleteAttachmentConfirmationMessage: string =
  ChangeControlLibraryConstants.Deleted_Attachments_Confirmation_Message;
  deletedAttachments : ChangeControlAttachmentDetails[] = [];
  showDeletedFilesConfirmationModal : boolean = false;
  implementationOwnersList:any=[];
  collaboratorsList:any=[];
  reviewersList:any=[];
  approversList:any=[];
  verifiersList:any=[];
  internalClientContactsList:any=[];
  notifiedUsersList:any=[];
  implementationOwnersListWithInactiveUsers:any=[];
  collaboratorsListWithInactiveUsers:any=[];
  reviewersListWithInactiveUsers:any=[];
  approversListWithInactiveUsers:any=[];
  verifiersListWithInactiveUsers:any=[];
  internalClientContactsListWithInactiveUsers:any=[];
  notifiedUsersListWithInactiveUsers:any=[];
  usersListToValidate:any=[];
  validatedUsersList:any=[];
  inactiveUserSelected:any;
  inactiveGroupsSelected:any;
  isInActiveAssignmentGroupDialog:boolean = false;
  InactiveAssignmentGroupField = '';
  isReasonRequired:boolean=false;
isReasonForChangeControlUpdateRequired = false;
  reasonForChangeControlUpdate = '';
 heading: string = ChangeControlLibraryConstants.ReasonHeading;
  reasonValidationMessage: string = ChangeControlLibraryConstants.ReasonValidationMessage;



  //Edit Slider Changes
  isEditSlider: boolean = false;

  constructor(
    private fb: FormBuilder,
    private changeControlService: ChangeControlService,
    private subBUService: ResponsibleSubBUService,
    private assignmentGroupSharedDataService: AssignmentGroupSharedDataService,
    private changecontrolPersistenceService: ChangecontrolPersistenceService,
    private usersService: UsersService
  ) {
    this.initChangeControlForm();
  }

  ngOnInit(): void {
    this.changecontrolPersistenceService.changeControlSaveInProgress$.subscribe(
    (changeControlSaveStatus) => {
      this.isChangeControlSaveInProgress = changeControlSaveStatus;
    }
  );
    this.minStartDateValue.setHours(0, 0, 0, 0);
  
    // Call APIs concurrently
    forkJoin({
      lookUpData: this.changeControlService.getChangeControlLookUpDetails(),
      scopeList: this.changeControlService.getScopesForChangeControl(),
      subBUData: this.subBUService.getSubBU(),
    }).subscribe({
      next: async ({ lookUpData, scopeList, subBUData }) => {
          // Update component state with fetched data
          this.lookupData = lookUpData;
          this.populateEQMSScopeList(scopeList);
          this.sbuList = subBUData.map((dataItem: any) => ({
            value: `${dataItem.Code} ${dataItem.Name}`,
            name: `${dataItem.Code} ${dataItem.Name}`,
          }));
          this.islookupDataLoaded = true;
  
          // Await async operation within observable subscription
          await this.validateEqmsScopes();
          this.changeControlForm.patchValue({
          targetCompletionDate : new Date(this.changeControlDetails?.targetCompletionDate?? '')
          });

      },
      error: (error) => {
        console.error('Error while fetching data:', error);
      },
    });
  
    // Handle change control slider edit
    if (this.changecontrolPersistenceService.isChangeControlEditSlider) {
      this.isEditSlider = true;
      this.loadEditDocumentSlider();
      this.patchValueForChangeControl(this.changeControlDetails);
      this.changecontrolPersistenceService.updateRelatedDocuments(this.changeControlDetails.relatedDocuments);
    }
  
    // Subscribe to tab changes
    this.changecontrolPersistenceService.currentTabInSliderMenuByCustomChange$.subscribe((tabIndex) => {
      if (tabIndex === ChangeControlLibraryConstants.ChangeControl_Menu_General_Tab_Index) {
        this.loadEditDocumentSlider();
        this.patchValueForChangeControl(this.changecontrolPersistenceService.changeManagementDetails$.value);
      }
    });
  
    this.changecontrolPersistenceService.currentTabInSliderMenu$.subscribe((tabIndex) => {
      if (tabIndex === ChangeControlLibraryConstants.ChangeControl_Menu_General_Tab_Index) {
        this.calculateFormData();
      }
    });
  }

  private populateEQMSScopeList(locationsData: any): void {
    for (let dataItem of locationsData) {
      this.eQMSScopeList.push({
        value: dataItem.eQMSScopeId,
        name: dataItem.eQMSScopeName,
      });
    }
  }
  
  async loadUserList(scopes: number[]): Promise<void> {
      // Convert the observable to a promise
      const usersData = await firstValueFrom(this.changeControlService.getUsersForChangeControl(scopes));
      
      // Process the data
      this.userList = usersData.map((dataItem) => ({
        value: dataItem.name,
        name: dataItem.name
      }));
  
      // Initialize user lists
      await this.initializeUserLists();
  }



  private async initializeUserLists(): Promise<void> {
    // If it is for create document slider, load the default users lists based on logic
    if(!this.isEditSlider)
    {
      //initialize all the lists
      this.implementationOwnersList=[];
      this.collaboratorsList=[];
      this.reviewersList=[];
      this.approversList=[];
      this.verifiersList=[];
      this.internalClientContactsList=[];
      this.notifiedUsersList=[];
    
      //Assigned usersList for all the dropdowns and temporary lists
      this.implementationOwnersList=[...this.userList];
      this.collaboratorsList=[...this.userList];
      this.reviewersList=[...this.userList];
      this.approversList=[...this.userList];
      this.verifiersList=[...this.userList];
      this.internalClientContactsList=[...this.userList];
      this.notifiedUsersList=[...this.userList];
      this.implementationOwnersListWithInactiveUsers=[...this.userList];
      this.collaboratorsListWithInactiveUsers=[...this.userList];
      this.reviewersListWithInactiveUsers=[...this.userList];
      this.approversListWithInactiveUsers=[...this.userList];
      this.verifiersListWithInactiveUsers=[...this.userList];
      this.internalClientContactsListWithInactiveUsers=[...this.userList];
      this.notifiedUsersListWithInactiveUsers=[...this.userList];

    }
    
    //If it is edit slider, process the users list drop downs for inactive users presence
    else
    {
      this.usersListToValidate=[];
      this.implementationOwnersListWithInactiveUsers=[...this.userList];
      this.collaboratorsListWithInactiveUsers=[...this.userList];
      this.reviewersListWithInactiveUsers=[...this.userList];
      this.approversListWithInactiveUsers=[...this.userList];
      this.verifiersListWithInactiveUsers=[...this.userList];
      this.internalClientContactsListWithInactiveUsers=[...this.userList];
      this.notifiedUsersListWithInactiveUsers=[...this.userList];

      this.usersListToValidate.push({
        userType:UserType.CCImplementationOwner,
        userAssignmentList: this.changeControlDetails.implementationOwnerNames
      });
      
      this.usersListToValidate.push({
        userType:UserType.CCCollaborator,
        userAssignmentList: this.changeControlDetails.collaboratorNames
      });

      this.usersListToValidate.push({
        userType:UserType.CCReviewer,
        userAssignmentList: this.changeControlDetails.reviewerNames
      });

      this.usersListToValidate.push({
        userType:UserType.CCApprover,
        userAssignmentList: this.changeControlDetails.approverNames
      });

      this.usersListToValidate.push({
        userType:UserType.CCVerifier,
        userAssignmentList: this.changeControlDetails.verifierNames
      });

      if(this.changeControlDetails.internalClientContactName != null && this.changeControlDetails.internalClientContactName != undefined && 
        this.changeControlDetails.internalClientContactName?.assignedUserName != null){
        
        let internalClientContactNamesList:any=[];
        internalClientContactNamesList.push(this.changeControlDetails.internalClientContactName);
        this.usersListToValidate.push({
          userType:UserType.CCInternalClientContact,
          userAssignmentList: internalClientContactNamesList
        });
      }

       if(this.changeControlDetails.notifiedUserNames != null && this.changeControlDetails.notifiedUserNames != undefined){
         this.usersListToValidate.push({
           userType:UserType.CCNotifiedUser,
           userAssignmentList: this.changeControlDetails.notifiedUserNames
          });
        }

// Fetch and process the validated users list
this.validatedUsersList = await firstValueFrom(this.usersService.validateUsers(this.usersListToValidate));
this.changecontrolPersistenceService.validatedUsersList = this.validatedUsersList;
this.changecontrolPersistenceService.usersList = this.userList;

if (this.validatedUsersList.length > 0) {
    // Iterate through each userInfo in the validatedUsersList
    this.validatedUsersList.forEach((userInfo: { userAssignmentList: any[]; userType: any; }) => {
        // Filter only inactive user types for binding dropdown lists
        const filteredAssignments = userInfo.userAssignmentList.filter(assignment => assignment.assignmentType != 0);

        // Determine the target list based on user type
        let targetList: { name: string, value: string }[] = [];

        switch (userInfo.userType) {
            case UserType.CCImplementationOwner:
                targetList = this.implementationOwnersListWithInactiveUsers;
                break;
            case UserType.CCCollaborator:
                targetList = this.collaboratorsListWithInactiveUsers;
                break;
            case UserType.CCReviewer:
                targetList = this.reviewersListWithInactiveUsers;
                break;
            case UserType.CCApprover:
                targetList = this.approversListWithInactiveUsers;
                break;
            case UserType.CCVerifier:
                targetList = this.verifiersListWithInactiveUsers;
                break;
            case UserType.CCInternalClientContact:
                targetList = this.internalClientContactsListWithInactiveUsers;
                break;
            case UserType.CCNotifiedUser:
                targetList = this.notifiedUsersListWithInactiveUsers;
                break;
            default:
                return; // Skip unknown user types
        }

        // Add filtered assignments to the target list
        filteredAssignments.forEach(user => {
            const userItem = { name: user.assignedUserName, value: user.assignedUserName };

            // Check if the item already exists in the target list
            if (!targetList.some(item => item.name === userItem.name && item.value === userItem.value)) {
                targetList.push(userItem);
            }
        });
    });
}

      this.implementationOwnersList=[...this.implementationOwnersListWithInactiveUsers];
      this.collaboratorsList=[...this.collaboratorsListWithInactiveUsers];
      this.reviewersList=[...this.reviewersListWithInactiveUsers];
      this.approversList=[...this.approversListWithInactiveUsers];
      this.verifiersList=[...this.verifiersListWithInactiveUsers];
      this.internalClientContactsList=[...this.internalClientContactsListWithInactiveUsers];
      this.notifiedUsersList=[...this.notifiedUsersListWithInactiveUsers];
    }
  }


  private initChangeControlForm(): void {
    this.changeControlForm = this.fb.group({
      title: ['', Validators.required],
      priority: [null, Validators.required],
      reason: [null, Validators.required],
      impact: [null, Validators.required],
      category: [null, Validators.required],
      changeRequestSource: [null, Validators.required],
      targetCompletionDate: [
        null,
        [Validators.required, this.futureDateValidator],
      ],
      riskAssessmentRequired: [false, Validators.required],
      currentState: ['', Validators.required],
      futureState: ['', Validators.required],
      rationale: ['', Validators.required],
      eQMSScopes : [null, Validators.required],
      responsibleSubBU: [[], Validators.required],
      clientNotificationOrApprovalRequired: [false, Validators.required],
      implementationOwners: [null, Validators.required],
      collaborators: [null, Validators.required],
      internalClientContact: [{ value: null, disabled: true }],
      reviewers: [null, Validators.required],
      approvers: [null, Validators.required],
      verifiers: [null, Validators.required],
      notifiedUsers: [[]],
    });

    this.setupClientNotificationValidation();
  }

  private setupClientNotificationValidation(): void {
    const clientNotificationControl = this.changeControlForm.get(ChangeControlLabels.ClientNotificationOrApprovalRequired);
    const internalClientContactControl = this.changeControlForm.get(ChangeControlLabels.InternalClientContact);
    const eQMSScopesControl = this.changeControlForm.get('eQMSScope');
  
    if (!clientNotificationControl || !internalClientContactControl || !eQMSScopesControl) {
      return;
    }
  
    clientNotificationControl.valueChanges.subscribe((value) => {
      const eQMSScopesValue = eQMSScopesControl.value;
      if (value && eQMSScopesValue?.length) {
        internalClientContactControl.enable();
        internalClientContactControl.setValidators([Validators.required]);
        this.isInternalClientContactRequired = true
      } else {
        internalClientContactControl.disable();
        internalClientContactControl.clearValidators();
        internalClientContactControl.setValue(null);
        this.isInternalClientContactRequired = false;
      }
      internalClientContactControl.updateValueAndValidity();
    });
  }  

  private futureDateValidator(control: {
    value: Date;
  }): { [key: string]: any } | null {
    const currentDate = new Date();
    const selectedDate = new Date(control.value);
    return selectedDate.getFullYear() < currentDate.getFullYear() ||
    (selectedDate.getFullYear() === currentDate.getFullYear() &&
      selectedDate.getMonth() < currentDate.getMonth()) ||
    (selectedDate.getFullYear() === currentDate.getFullYear() &&
      selectedDate.getMonth() === currentDate.getMonth() &&
      selectedDate.getDate() < currentDate.getDate()) ? { invalidDate: true } : null;
  }

  async validateEqmsScopes(): Promise<void> {
    try {
      const eQMSScopes = this.changeControlForm.getRawValue().eQMSScopes;
      const clientNotificationOrApprovalRequired = this.changeControlForm.get(ChangeControlLabels.ClientNotificationOrApprovalRequired)?.value;
      const controlNamesToEnableDisable = [
        ChangeControlLabels.Collaborators,
        ChangeControlLabels.ImplementationOwners,
        ChangeControlLabels.Reviewers,
        ChangeControlLabels.Approvers,
        ChangeControlLabels.Verifiers,
        ChangeControlLabels.NotifiedUsers,
        ChangeControlLabels.InternalClientContact
      ];
  
      if (eQMSScopes?.length) {
        if (!this.isEditSlider) {
          this.changecontrolPersistenceService.enableDisableControls(this.changeControlForm, true, controlNamesToEnableDisable);
        }
  
        // Await the asynchronous operation to load the user list
        await this.loadUserList(eQMSScopes);
  
        // Conditionally enable/disable control based on clientNotificationOrApprovalRequired
        if (clientNotificationOrApprovalRequired) {
          this.changeControlForm.get(ChangeControlLabels.InternalClientContact)?.enable();
          this.isInternalClientContactRequired = true;
        } else {
          this.changeControlForm.get(ChangeControlLabels.InternalClientContact)?.disable();
          this.isInternalClientContactRequired = false;
        }
      } else {
        if (!this.isEditSlider) {
          this.changecontrolPersistenceService.enableDisableControls(this.changeControlForm, false, controlNamesToEnableDisable);
        }
        this.isInternalClientContactRequired = false;
      }
    } catch (error) {
      console.error('Error validating eQMS scopes:', error);
      // Optionally, handle or report the error further as needed
    }
  }
  


  VerifyReviewerAndApprover() {
    if (
      this.changeControlForm.getRawValue().approvers !== null &&
      this.changeControlForm.getRawValue().reviewers !== null
    )
      this.validationErrorOnApproverAndReviewerEnable =
        this.changeControlForm.getRawValue().approvers.length ===
          this.changeControlForm.getRawValue().reviewers.length &&
        this.changeControlForm
          .getRawValue()
          .approvers.every((value: string) =>
            this.changeControlForm.getRawValue().reviewers.includes(value)
          );
  }

  async submitForm(): Promise<void> {
    this.saveClicked = true;
    if (this.isValidForm()) {
        await this.calculateFormData();
        if (!this.isEditSlider) {
            this.saveChangeManagement();
        }
        else {
          await this.updateChangeManagement()
        }
    } else {
      this.scrollToTop();
    }
  }


  validateUsersAndUpdateChangeManagement(formdataValue:any){
    this.patchValueForChangeControl(this.formData);
    this.inactiveUserSelected = undefined;
    this.inactiveGroupsSelected = undefined;
    this.inactiveGroupsSelected = this.assignmentGroupSharedDataService.findInactiveObjectsInValidatedList(formdataValue, this.validatedUsersList, this.userList);
    if(this.inactiveGroupsSelected != undefined && this.inactiveGroupsSelected.length > 0){
      this.isInActiveAssignmentGroupDialog = true;   
      this.InactiveAssignmentGroupField = this.inactiveGroupsSelected;
     }
     else{
      this.changecontrolPersistenceService.updateChangeManagement();
     }
  }

  saveAssignmentGroupwithInactiveUsers(){
    this.isInActiveAssignmentGroupDialog = false;
    this.changecontrolPersistenceService.updateChangeManagement();
  }

  async closeConfirmationDailog(value : boolean){    
  this.isInActiveAssignmentGroupDialog = value
  }

  
  
  private isValidForm(): boolean {
    this.validateForm();
    this.checkValidationRules();
    return this.errorMessages.length === 0;
  }
  
  private async calculateFormData(): Promise<void> {
    this.updateAssignments();
    this.formData= this.changeControlForm.getRawValue();
    if(!this.isEditSlider){
      this.formData.number = ''
    }
    else{
      this.formData.number = this.changeControlDetails.number;
    }
    this.changecontrolPersistenceService.updateChangeManagementDetails(this.formData);
  }
  
  private saveChangeManagement(): void {
    this.changecontrolPersistenceService.saveChangeManagement();
     this.reasonForChangeControlUpdate = '';
  }

  openNextTab = async () => {
    this.validateForm();
    this.checkValidationRules();
        if (this.errorMessages.length === 0) {
      if (this.isEditSlider) {
        await this.calculateFormData();
        this.changecontrolPersistenceService.validatedUsersList=this.validatedUsersList;
        this.changecontrolPersistenceService.usersList=this.userList;
        this.changecontrolPersistenceService.updateTabErrorIndex(ChangeControlLibraryConstants.ChangeControl_Menu_General_Tab_Index, false);
      }
      else{
        await this.calculateFormData();
      }
      this.changecontrolPersistenceService.updateChangeManagementDetails(this.formData);
      this.activateTabIndex.emit(
        ChangeControlLibraryConstants.ChangeControl_Menu_File_Tab_Index
      );
      this.changecontrolPersistenceService.onCustomTabChange(ChangeControlLibraryConstants.ChangeControl_Menu_File_Tab_Index);
    } else {
      if (this.isEditSlider) {
        this.changecontrolPersistenceService.updateChangeManagementDetails(this.formData);
        this.changecontrolPersistenceService.updateTabErrorIndex(ChangeControlLibraryConstants.ChangeControl_Menu_General_Tab_Index, true);
        this.activateTabIndex.emit(
          ChangeControlLibraryConstants.ChangeControl_Menu_File_Tab_Index
        );
        this.changecontrolPersistenceService.onCustomTabChange(ChangeControlLibraryConstants.ChangeControl_Menu_File_Tab_Index);
      }
      else
        document.querySelector('.p-tabview-panels')?.scrollTo(0, 0);
    }
  };


  async updateChangeManagement() {
    this.deletedAttachments = [];
    this.saveClicked = true;
    await this.calculateFormData();
    this.validateForm();
    this.checkValidationRules();
    if (this.errorMessages.length === 0) {
      this.changecontrolPersistenceService.updateTabErrorIndex(ChangeControlLibraryConstants.ChangeControl_Menu_General_Tab_Index
        , false);
        this.deletedAttachments = this.changecontrolPersistenceService.deletedChangeControlAttachments;
        if (this.deletedAttachments.length > 0) {
          this.showDeletedFilesConfirmationModal = true;
        }
        else{
              this.isReasonRequired= false;
        this.isReasonRequired = [
        ChangeControlPhase.Implementation,
        ChangeControlPhase.Verification,
        ChangeControlPhase.Complete].includes(this.changeControlDetails.phase);

        if (this.isReasonRequired) {
          this.updateReasonForEditorSave();
        } 
        else{
          this.changecontrolPersistenceService.updateChangeManagementDetails(this.formData);
          this.validateUsersAndUpdateChangeManagement(this.formData);
        }
        }

    } else {

      if (this.isEditSlider) {
        this.changecontrolPersistenceService.updateTabErrorIndex(ChangeControlLibraryConstants.ChangeControl_Menu_General_Tab_Index
          , true);
      }
      this.patchValueForChangeControl(this.formData);
      document.querySelector('.p-tabview-panels')?.scrollTo(0, 0);
    }
  }


updateReasonForEditorSave() {
  const phasesToCheck = [
    ChangeControlPhase.Implementation,
    ChangeControlPhase.Verification,
    ChangeControlPhase.Complete
  ];

  if (phasesToCheck.includes(this.changeControlDetails.phase) && !this.reasonForChangeControlUpdate.length) {
    this.isReasonForChangeControlUpdateRequired = true;
  } else {
    this.changecontrolPersistenceService.updateChangeManagementDetails(this.formData);
    this.validateUsersAndUpdateChangeManagement(this.formData);
  }
}

 closeReasonDailog(value: boolean) {
    this.isReasonForChangeControlUpdateRequired = value;
    this.loadEditDocumentSlider();
      this.patchValueForChangeControl(this.changeControlDetails);
  }

  saveChangeControlwithReason(value: any) {
    this.reasonForChangeControlUpdate = value;
    this.isReasonForChangeControlUpdateRequired = false;
    this.changecontrolPersistenceService.reasonForChangeControlUpdate=this.reasonForChangeControlUpdate;
    this.changecontrolPersistenceService.updateChangeManagementDetails(this.formData);
          this.validateUsersAndUpdateChangeManagement(this.formData);
  }


  UpdateChangeControl=()=>
    {
        this.changecontrolPersistenceService.updateChangeManagementDetails(this.formData);
        this.changecontrolPersistenceService.updateChangeManagement();
        this.showDeletedFilesConfirmationModal= false;
    }

    closeConfirmationModal = () => {
      this.showDeletedFilesConfirmationModal = false;
    };

  updateAssignments(): void {
    this.changecontrolPersistenceService.updateAssignment(ChangeControlLabels.Collaborators, this.changeControlForm, this.collaboratorsListWithInactiveUsers, this.assignmentGroups);
    this.changecontrolPersistenceService.updateAssignment(ChangeControlLabels.ImplementationOwners,this.changeControlForm, this.implementationOwnersListWithInactiveUsers, this.assignmentGroups);
    this.changecontrolPersistenceService.updateChangeControlUserAssignment(ChangeControlLabels.Reviewers, this.changeControlForm, this.reviewersListWithInactiveUsers);
    this.changecontrolPersistenceService.updateChangeControlUserAssignment(ChangeControlLabels.Approvers, this.changeControlForm, this.approversListWithInactiveUsers);
    this.changecontrolPersistenceService.updateChangeControlUserAssignment(ChangeControlLabels.Verifiers, this.changeControlForm, this.verifiersListWithInactiveUsers);
    this.changecontrolPersistenceService.updateAssignment(ChangeControlLabels.NotifiedUsers,this.changeControlForm, this.notifiedUsersListWithInactiveUsers, this.assignmentGroups);
    this.internalClientContact();
  }

  internalClientContact(): void {
    const formValues = this.changeControlForm.value;
    const internalClientContact =
      this.assignmentGroupSharedDataService.updateUserToAssignmentType(
        this.internalClientContactsListWithInactiveUsers,
        formValues.internalClientContact,
        this.assignmentGroups,
        []
      );
    this.changeControlForm.patchValue({
      internalClientContact: internalClientContact,
    });
  }

  private validateForm() {
    this.errorMessages = [];
    this.mandatoryFields = this.getDefaultMandatoryFieldsObject();
    if (this.changeControlForm.invalid) {
      Object.keys(this.changeControlForm.controls).forEach((key) => {
        if (this.changeControlForm.get(key)?.errors) {
          let errorText = this.getErrorMessageText(key);
          errorText && this.errorMessages.push(errorText);
        }
      });
    }
  }

  private checkValidationRules() {
    this.checkIfReviewerAndApproverAreSame();
    this.checkIfInternalClientContactIsNotApplicable();
  }

  private checkIfReviewerAndApproverAreSame() {
    if (this.validationErrorOnApproverAndReviewerEnable)
      this.errorMessages.push(
        ChangeControlLibraryConstants.ChangeControl_ApproverReviewerValidation_ErrorMessage
      );
  }

  private scrollToTop(): void {
    document.querySelector('.p-tabview-panels')?.scrollTo(0, 0);
  }
  

  private checkIfInternalClientContactIsNotApplicable(){
    this.isInternalClientContactMandatory = this.isInternalClientContactRequired && 
    (this.changeControlForm.getRawValue().internalClientContact == null || 
    (this.changeControlForm.getRawValue().internalClientContact != null && this.changeControlForm.getRawValue().internalClientContact.length == 0));
    if(this.isInternalClientContactMandatory)
      this.errorMessages.push(ChangeControlLibraryConstants.ChangeControl_InternalClientContact_Required);
  }

  private getErrorMessageText(labelName: string) {
    let errorText: string = '';
    switch (labelName) {
      case 'title':
        errorText = ChangeControlLibraryConstants.ChangeControl_Title_Required;
        this.mandatoryFields.title = true;
        break;
      case 'priority':
        errorText =
          ChangeControlLibraryConstants.ChangeControl_Priority_Required;
        this.mandatoryFields.priority = true;
        break;
      case 'reason':
        errorText = ChangeControlLibraryConstants.ChangeControl_Reason_Required;
        this.mandatoryFields.reason = true;
        break;
      case 'impact':
        errorText = ChangeControlLibraryConstants.ChangeControl_Impact_Required;
        this.mandatoryFields.impact = true;
        break;
      case 'category':
        errorText =
          ChangeControlLibraryConstants.ChangeControl_Category_Required;
        this.mandatoryFields.category = true;
        break;
      case 'eQMSScopes':
        errorText =
          ChangeControlLibraryConstants.ChangeControl_eQMSScope_Required;
        this.mandatoryFields.eQMSScopes = true;
        break;
      case 'changeRequestSource':
        errorText =
          ChangeControlLibraryConstants.ChangeControl_ChangeRequestSource_Required;
        this.mandatoryFields.changeRequestSource = true;
        break;
      case 'currentState':
        errorText =
          ChangeControlLibraryConstants.ChangeControl_CurrentState_Required;
        this.mandatoryFields.currentState = true;
        break;
      case 'futureState':
        errorText =
          ChangeControlLibraryConstants.ChangeControl_FutureState_Required;
        this.mandatoryFields.futureState = true;
        break;
      case 'rationale':
        errorText =
          ChangeControlLibraryConstants.ChangeControl_Rationale_Required;
        this.mandatoryFields.rationale = true;
        break;
      case 'targetCompletionDate':
        errorText =
          ChangeControlLibraryConstants.ChangeControl_TargetCompletionDate_Required;
        this.mandatoryFields.targetCompletionDate = true;
        break;
      case 'responsibleSubBU':
        errorText = ChangeControlLibraryConstants.ChangeControl_SubBU_Required;
        this.mandatoryFields.responsibleSubBU = true;
        break;
      case 'implementationOwners':
        errorText =
          ChangeControlLibraryConstants.ChangeControl_ImplementationOwners_Required;
        this.mandatoryFields.implementationOwners = true;
        break;
      case 'collaborators':
        errorText =
          ChangeControlLibraryConstants.ChangeControl_Collaborators_Required;
        this.mandatoryFields.collaborators = true;
        break;
      case 'reviewers':
        errorText =
          ChangeControlLibraryConstants.ChangeControl_Reviewers_Required;
        this.mandatoryFields.reviewers = true;
        break;
      case 'approvers':
        errorText =
          ChangeControlLibraryConstants.ChangeControl_Approvers_Required;
        this.mandatoryFields.approvers = true;
        break;
      case 'verifiers':
        errorText =
          ChangeControlLibraryConstants.ChangeControl_Verifiers_Required;
        this.mandatoryFields.verifiers = true;
        break;
    }
    return errorText;
  }

  private getDefaultMandatoryFieldsObject() {
    return {
      title: false,
      priority: false,
      reason: false,
      impact: false,
      category: false,
      eQMSScopes: false,
      changeRequestSource: false,
      currentState: false,
      futureState: false,
      rationale: false,
      targetCompletionDate: false,
      responsibleSubBU: false,
      implementationOwners: false,
      collaborators: false,
      reviewers: false,
      approvers: false,
      verifiers: false,
    };
  }

  //Edit Slider - populating datas
  async loadEditDocumentSlider() {
    if (this.isEditSlider) {
      this.populateChangeControlDetailsForEdit();
      this.changeControlSaveProgressMessage =
      ChangeControlLibraryConstants.ChangeControl_Update_InProgress;
    }
}

populateChangeControlDetailsForEdit(){
  this.ifPhaseIsInReviewAndBeyond() ? 
  this.changecontrolPersistenceService.enableDisableControls(this.changeControlForm, false, [ChangeControlLabels.Reviewers]) 
  : this.changecontrolPersistenceService.enableDisableControls(this.changeControlForm, true, [ChangeControlLabels.Reviewers]);
  this.ifPhaseIsReadyForApprovalAndBeyond() ? 
  this.changecontrolPersistenceService.enableDisableControls(this.changeControlForm, false, [ChangeControlLabels.Approvers]) 
  : this.changecontrolPersistenceService.enableDisableControls(this.changeControlForm, true, [ChangeControlLabels.Approvers]);
} 

patchValueForChangeControl(changeControlDetails : any){  
  this.changeControlForm.patchValue(
    {
    title: changeControlDetails.title,
    priority: changeControlDetails.priority,
    reason: changeControlDetails.reason,
    impact: changeControlDetails.impact,
    category: changeControlDetails.category,
    changeRequestSource: changeControlDetails.changeRequestSource,
    riskAssessmentRequired: changeControlDetails.riskAssessmentRequired,
    currentState: changeControlDetails.currentState,
    futureState: changeControlDetails.futureState,
    rationale: changeControlDetails.rationale,
    eQMSScopes : changeControlDetails.eQMSScopes,
    responsibleSubBU: changeControlDetails.responsibleSubBU || [],
    clientNotificationOrApprovalRequired: changeControlDetails.clientNotificationOrApprovalRequired,
    implementationOwners: changeControlDetails.implementationOwners.map((obj: Assignment) =>obj.assignedUserName),
    collaborators: changeControlDetails.collaborators.map((obj: Assignment)=>obj.assignedUserName),
    internalClientContact: changeControlDetails.internalClientContact != null? changeControlDetails.internalClientContact.assignedUserName : null,
    reviewers: changeControlDetails.reviewers.map((obj : AssignmentDisplayDetails)=>obj.name),
    approvers: changeControlDetails.approvers.map((obj : AssignmentDisplayDetails)=>obj.name),
    verifiers: changeControlDetails.verifiers.map((obj : AssignmentDisplayDetails)=>obj.name),
    notifiedUsers: changeControlDetails.notifiedUsers != null? 
    changeControlDetails.notifiedUsers.map((obj: Assignment)=>obj.assignedUserName) : null,
    targetCompletionDate : new Date(changeControlDetails.targetCompletionDate)
    })
  }



ifPhaseIsInReviewAndBeyond() : boolean{
  return this.changeControlDetails.phase == ChangeControlPhase.InReview || this.changeControlDetails.phase > ChangeControlPhase.InReview
}

ifPhaseIsReadyForApprovalAndBeyond(){
  return this.changeControlDetails.phase == ChangeControlPhase.ReadyForApproval || this.changeControlDetails.phase > ChangeControlPhase.ReadyForApproval
}

}
